import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import './styles.css';
import { App } from './app/App';
import { applyUrlParams } from './platform/store';
import { primeTheme } from './platform/theme';

// Apply preferences and the last known organization theme before the first paint (no flash of default colours).
applyUrlParams();
primeTheme();
// Keep the in-memory prototype out of live builds; in prototype mode registration still completes before React can request data.
if (import.meta.env.VITE_API_MODE === 'mock') {
  const { registerPrototypeApps } = await import('./app/prototypeApps');
  registerPrototypeApps();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
